import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Rocket } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 bg-palomitas-dark relative overflow-hidden" data-id="element-79">
      {/* Colorful decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-80">
        <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-palomitas-coral/15 rounded-full blur-3xl" data-id="element-81"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-palomitas-pink/15 rounded-full blur-3xl" data-id="element-82"></div>
        <div className="absolute top-[30%] right-[20%] w-64 h-64 bg-palomitas-gold/10 rounded-full blur-3xl" data-id="element-83"></div>
      </div>

      <div className="container relative z-10 px-4 mx-auto max-w-4xl text-center" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-85">
          <Rocket className="mx-auto mb-6 text-palomitas-gold" size={48} data-id="element-86" />
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8" data-id="element-87">
            ¿Lista para empezar a generar ingresos desde tu cocina?
          </h2>

          <p className="text-xl text-palomitas-beige mb-12 max-w-2xl mx-auto" data-id="element-88">
            No necesitás experiencia previa, solo las ganas de aprender y
            aplicar un sistema probado.
          </p>

          <div className="flex justify-center" data-id="element-89">
            <Button href="#oferta" className="w-full sm:w-auto text-xl px-10 py-5" data-id="element-90">
              👉 Empezar ahora
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}